import React, { useEffect, useState } from 'react';
import { getUserContentSuggestions } from './utils/contentSuggestions';
import { getTenant } from './helpers';
export function useContentSuggestions (contentType:string, username?: string) {

  const [content, setContent] = useState<any>(null)
  const [contentLoaded, setContentLoaded] = useState(false)

   const query : any= {
      username: username,
      platform_key: getTenant(),
    }; 

  useEffect(() => {
    getUserContentSuggestions(contentType, query).then((response)=>{
      setContent(response)
      setContentLoaded(true)
    }).catch(()=>{
      setContent([])
      setContentLoaded(true)
    })
  }, []);

  return {
    content, contentLoaded
  }
}